import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const LOGO = "https://customer-assets.emergentagent.com/job_rivera-ny-senate/artifacts/aasxup92_7815758719719681036.png";

export const LegalLayout = ({ children, otherLink }) => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="bg-gray-50 min-h-screen" data-testid="legal-page">
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-100">
        <div className="container mx-auto px-4 md:px-8 max-w-7xl flex items-center justify-between h-24">
          <Link to="/" data-testid="legal-logo-home-link">
            <img src={LOGO} alt="Orlando Rivera for New York State Senate" className="h-16 md:h-20 w-auto object-contain" />
          </Link>
          <Link to="/" className="flex items-center gap-2 text-sm font-bold uppercase tracking-widest hover:text-campaignRed transition-colors" data-testid="legal-back-home">
            <ArrowLeft size={18} /> Back to Home
          </Link>
        </div>
      </header>
      {children}
      <footer className="bg-campaignBlack text-gray-400 py-10 text-center text-xs space-y-3">
        <Link to={otherLink.to} className="hover:text-white underline" data-testid="legal-other-link">{otherLink.label}</Link>
        <p>© {new Date().getFullYear()} Rivera for NY Senate. All rights reserved.</p>
      </footer>
    </div>
  );
};
